import { render, staticRenderFns } from "./GroupsManagement.html?vue&type=template&id=60995bd9&scoped=true&external"
import script from "./GroupsManagement.js?vue&type=script&lang=js&external"
export * from "./GroupsManagement.js?vue&type=script&lang=js&external"
import style0 from "./GroupsManagement.scss?vue&type=style&index=0&id=60995bd9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60995bd9",
  null
  
)

export default component.exports